module.exports = __webpack_public_path__ + "media/images/home/banner_bg-e7b8afdec411383093fb52dd25837850.png";